/* hospital.icon.svg.js */

module.exports = {
    icon: `<svg width="24" height="24" viewBox="2 1 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_5517_388" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
<path d="M24 0H0V24H24V0Z" class="foreground-gl"/>
</mask>
<g>
<path d="M2 21V4.75L7 1L12 4.75V7H22V21H2ZM4 19H6V17H4V19ZM4 15H6V13H4V15ZM4 11H6V9H4V11ZM4 7H6V5H4V7ZM8 7H10V5H8V7ZM8 19H20V9H8V19Z" class="foreground-gl"/>
<path d="M11.0774 17.3169V10.2946H12.9838V13.0377H15.5074V10.2946H17.4138V17.3169H15.5074V14.5738H12.9838V17.3169H11.0774Z" class="foreground-gl"/>
</g>
</svg>`,
};
